import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { notificationAction } from '../../utils/notificationActions';

export default function NotificationPreview({ title, body, destination, buttonText, showHint = true }) {
  const action = notificationAction(destination);
  return <Box aria-label="Notification preview" sx={{ minWidth: 0 }}>
    <Box sx={{ bgcolor: '#F1F3F5', border: '1px solid #E2E8F0', borderRadius: 3, p: 3 }}>
      <Typography variant="overline" color="text.secondary">Notification preview</Typography>
      <Box sx={{ bgcolor: '#fff', borderRadius: 2.5, p: 2, mt: 1, boxShadow: '0 4px 18px #0F172A0A' }}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1.5 }}>
          <NotificationsNoneIcon sx={{ fontSize: 18, color: '#475569' }} />
          <Typography variant="caption" fontWeight={600} color="text.secondary">MYCASECARE</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto !important' }}>now</Typography>
        </Stack>
        <Typography fontWeight={600} sx={{ overflowWrap: 'anywhere' }}>{title || 'Your notification title'}</Typography>
        <Typography variant="body2" sx={{ mt: .5, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', color: 'text.secondary' }}>{body || 'Your message will appear here.'}</Typography>
        {action && <Box sx={{ borderTop: '1px solid #E2E8F0', mt: 2, pt: 1.5 }}>
          <Typography fontSize={14} fontWeight={600}>{buttonText?.trim() || 'Your button text'}</Typography>
        </Box>}
      </Box>
    </Box>
    {showHint && <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 1.5 }}>Appearance varies by device. Buttons may appear when the notification is expanded and require an updated app.</Typography>}
  </Box>;
}
